import { useLang } from "@/lib/lang";
import { apps } from "@/lib/apps";
import { Eyebrow, MaskLines, Reveal } from "@/components/motion";
import { AppCard } from "@/components/AppCard";

const layout = [
  ["hero", "col-span-12 lg:col-span-7 lg:row-span-2"],
  ["side", "col-span-12 md:col-span-6 lg:col-span-5"],
  ["side", "col-span-12 md:col-span-6 lg:col-span-5"],
  ["wide", "col-span-12"],
];

export const AppsBento = () => {
  const { t, lang } = useLang();
  return (
    <section id="apps" data-testid="apps-section" className="relative py-24 sm:py-36">
      <div className="container-x">
        <div className="mb-14 grid items-end gap-8 lg:grid-cols-12">
          <div className="lg:col-span-8">
            <Eyebrow>{t.apps.eyebrow}</Eyebrow>
            <h2 key={lang} data-testid="apps-title" className="section-title mt-6 font-display font-bold">
              <MaskLines inView lines={t.apps.titleLines} lineClassName={(i) => (i === 1 ? "text-white/40" : "")} />
            </h2>
          </div>
          <Reveal className="text-base leading-relaxed text-white/60 sm:text-lg lg:col-span-4">{t.apps.sub}</Reveal>
        </div>
        <div className="grid grid-cols-12 gap-4 lg:auto-rows-[minmax(330px,auto)] lg:gap-5">
          {apps.map((app, i) => (
            <AppCard key={app.slug} app={app} index={i} variant={layout[i][0]} className={layout[i][1]} />
          ))}
        </div>
      </div>
    </section>
  );
};
